<template>

  <CreditiUsciti />
 
</template>

<script>
import CreditiUsciti from '../components/pratiche/CreditiUsciti.vue'

export default {
  components: {
    CreditiUsciti
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

